import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  ModalBody,
  ModalHeader,
  Modal,
  CardSubtitle,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import { helper } from "lib/helper";
import levelModal from "models/level.modal";
import AddProfile from "./AddProfile";
import Editprofile from "./Editprofile";
const Profile = ({ dataList, getTutorsProfileDatarefesh }) => {

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };

  const [inputsPro, setInputsPro] = useState([{ id: 1, value: "" }]);

  const handleInputChangePro = (index, event) => {
    const values = [...inputsPro];
    values[index].value = event.target.value;
    setInputsPro(values);
  };
  const inputsProvalues = inputsPro && inputsPro?.map((item) => item.value);
  const handleAddInputPro = () => {
    const newInputs = [
      ...inputsPro,
      { id: inputsPro && inputsPro?.length + 1, value: "" },
    ];
    setInputsPro(newInputs);
  };
  const handleRemoveInputPro = (index) => {
    if (inputsPro && inputsPro?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsPro];
    values.splice(index, 1);
    setInputsPro(values);
  };

  const [inputsTech, setInputsTech] = useState([{ id: 1, value: "" }]);

  const handleInputChangeTech = (index, event) => {
    const values = [...inputsTech];
    values[index].value = event.target.value;
    setInputsTech(values);
  };
  const inputsTechvalues = inputsTech && inputsTech?.map((item) => item.value);
  const handleAddInputTech = () => {
    const newInputs = [
      ...inputsTech,
      { id: inputsTech && inputsTech?.length + 1, value: "" },
    ];
    setInputsTech(newInputs);
  };
  const handleRemoveInputTech = (index) => {
    if (inputsTech && inputsTech?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsTech];
    values.splice(index, 1);
    setInputsTech(values);
  };

  const [inputsBoards, setInputsBoards] = useState([{ id: 1, value: "" }]);

  const handleInputChangeBoords = (index, event) => {
    const values = [...inputsBoards];
    values[index].value = event.target.value;
    setInputsBoards(values);
  };
  const inputsBoardsvalues =
    inputsBoards && inputsBoards?.map((item) => item.value);
  const handleAddInputBoords = () => {
    const newInputs = [
      ...inputsBoards,
      { id: inputsBoards && inputsBoards?.length + 1, value: "" },
    ];
    setInputsBoards(newInputs);
  };
  const handleRemoveInputBoords = (index) => {
    if (inputsBoards && inputsBoards?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsBoards];
    values.splice(index, 1);
    setInputsBoards(values);
  };

  const [inputsGrade, setInputsGrade] = useState([{ id: 1, value: "" }]);

  const handleInputChangeGrade = (index, event) => {
    const values = [...inputsGrade];
    values[index].value = event.target.value;
    setInputsGrade(values);
  };
  const inputsGradevalues =
    inputsGrade && inputsGrade?.map((item) => item.value);
  const handleAddInputGrades = () => {
    const newInputs = [
      ...inputsGrade,
      { id: inputsGrade && inputsGrade?.length + 1, value: "" },
    ];
    setInputsGrade(newInputs);
  };
  const handleRemoveInputGrade = (index) => {
    if (inputsGrade && inputsGrade?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsGrade];
    values.splice(index, 1);
    setInputsGrade(values);
  };

  const [inputsEducation, setInputsEducation] = useState([
    { id: 1, value: "" },
  ]);
  const handleInputChangeEducation = (index, value) => {
    const values = [...inputsEducation];
    values[index] = { ...values[index], value }; // Update the value at the specified index
    setInputsEducation(values);
  };
  const inputsEducationvalues =
    inputsEducation && inputsEducation?.map((item) => item.value);
  const handleAddInputEducation = () => {
    const newInputs = [
      ...inputsEducation,
      { id: inputsEducation && inputsEducation?.length + 1, value: "" },
    ];
    setInputsEducation(newInputs);
  };
  const handleRemoveInputEducation = (index) => {
    if (inputsEducation && inputsEducation?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsEducation];
    values.splice(index, 1);
    setInputsEducation(values);
  };

  const [formData, setFormData] = useState({
    verified: "",
    stars: "",
    description: "",
    Year_Of_Exprinace: "",
    student_throught: "",
    about: "",
    status: "",
    vehicle: "",
    english_fluency: "",
  });

  // input valu change in formdata
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Store the value in the state
    }));
  };

  const handleInputChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked, // Store the checked state of the checkbox in the state
    }));
  };

  const [selectLevel, setSelectdLevel] = useState("");
  const handleSelectStatus = (id) => {
    setSelectdLevel(id);
  };

  const navigate = useNavigate();
  const params = useParams();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      tutor: parseInt(params.mid),
      verified: isChecked,
      stars: parseInt(formData.stars),
      description: formData.description,
      teaching_experience: [
        formData.Year_Of_Exprinace,
        formData.student_throught,
      ],
      professional_experience: inputsProvalues,
      about: formData.about,
      teaches: inputsTechvalues,
      boards: inputsBoardsvalues,
      grade: inputsGradevalues,
      education: inputsEducationvalues,
      vehicle: formData.vehicle,
      english_fluency: formData.english_fluency,
      level: parseInt(selectLevel),
    };
    tutorsModal
      .createTutorsProfile(data)
      .then((response) => {
        getTutorsProfileData();
        helper.sweetalert.toast(response.message, "success");
        toggle();
        // Display success message to the user
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);

  const location = useLocation();
  const [profile, setProfile] = useState("");
  const getTutorsProfileData = async (id) => {
    await tutorsModal
      .TutorsProfileGet(params.mid)
      .then((result) => {
        if (result) {
          getTutorsProfileDatarefesh();
          setProfile(result?.data?.data);
        }
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getTutorsProfileData();
  }, [location]);
  console.log(profile, "profilessss");

  const [ListLevel, setListLevel] = useState([]);
  const getListDataLevel = async () => {
    await levelModal
      .list()
      .then((result) => {
        if (result) {
          setListLevel(result?.data);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getListDataLevel();
  }, []);



  const stars = Array.from({ length: profile?.stars }, (_, index) => index + 1);
  return (
    <div>
      {profile == undefined ? (
        <Button onClick={toggle}>Add Profile</Button>
      ) : (
        <Button onClick={toggle1}>Edit Profile</Button>
      )}

      {profile && modal1 === false && (
        <Card
          style={{
            width: "100%",
          }}
          className="mt-2"
        >
          <CardBody
            style={{
              height: "80vh",
              overflowY: "scroll",
            }}
          >
            <Row>
              <Col md={6}>
                <CardTitle tag="h5">Status</CardTitle>
                <span style={{ fontSize: "14px" }}>
                  {" "}
                  {(profile?.verified === true && (
                    <span style={{ color: "green" }}>verified</span>
                  )) ||
                    "N/A"}
                </span>
              </Col>

              <Col md={6}>
                <CardTitle tag="h5">Level Name</CardTitle>
                <span style={{ fontSize: "14px" }}>
                  {profile?.level || "N/A"}
                </span>
              </Col>
            </Row>

            <hr />

            <CardTitle tag="h5">Teaching Experience</CardTitle>
            {profile?.teaching_experience &&
              profile?.teaching_experience?.map((item, index) => {
                return (
                  <>
                    <span
                      key={index}
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {index + 1}.{" "}
                    </span>
                    <span key={index} style={{ fontSize: "14px" }}>
                      {item}
                    </span>
                    <br />
                  </>
                );
              })}
            <hr />
            <CardTitle tag="h5">Professional Experience</CardTitle>
            {profile &&
              profile.professional_experience?.map((item, index) => (
                <>
                  <span
                    key={index}
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                  >
                    {index + 1}.{" "}
                  </span>
                  <span key={index} style={{ fontSize: "14px" }}>
                    {item}
                  </span>
                  <br />
                </>
              ))}
            <hr />
            <CardTitle tag="h5">About</CardTitle>
            <p style={{ fontSize: "14px" }}> {profile?.about}</p>
            <hr />
            <CardTitle tag="h5">Subject Teaches</CardTitle>
            {/* <Button style={{ fontWeight: "bold" }}>Subject Name</Button>{" "} */}
            {profile &&
              profile.teaches?.map((item, index) => <Button>{item}</Button>)}
            <hr />
            <CardTitle tag="h5">Boards</CardTitle>
            {/* <Button style={{ fontWeight: "bold" }}>Boards Name</Button>{" "} */}
            {profile &&
              profile.boards?.map((item, index) => <Button>{item}</Button>)}
            <hr />
            <CardTitle tag="h5">Grade</CardTitle>
            {/* <Button style={{ fontWeight: "bold" }}> Grade</Button>{" "} */}
            {profile &&
              profile.grade?.map((item, index) => <Button>{item}</Button>)}
            <hr />
            <CardTitle tag="h5">Education</CardTitle>
            {profile &&
              profile.education?.map((item, index) => (
                <>
                  <span
                    key={index}
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                  >
                    {index + 1}.{" "}
                  </span>
                  <span key={index} style={{ fontSize: "14px" }}>
                    {item}
                  </span>
                  <br />
                </>
              ))}
            <hr />
            <Row>
              <Col md={4}>
                <CardTitle tag="h5">Vehicle</CardTitle>
                <Button style={{ fontWeight: "bold" }}>
                  {" "}
                  {profile?.vehicle === true ? "yes" : "N/A"}
                </Button>
              </Col>
              <Col md={4}>
                <CardTitle tag="h5">English Fluency</CardTitle>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  {profile?.english_fluency || "-"}
                </span>
              </Col>
              <Col md={4}>
                <CardTitle tag="h5">Stamp of Badge</CardTitle>
                <Button style={{ fontWeight: "bold" }}>
                  {profile?.level && profile?.level}
                </Button>
              </Col>
            </Row>

            <hr />

            <CardTitle tag="h5">stars</CardTitle>
            {stars.slice(0, 5).map((_, index) => (
              <span key={index} className="ml-4">
                <i className="fa-solid fa-star" style={{ color: "gold" }}></i>
              </span>
            ))}
          </CardBody>
        </Card>
      )}

      {modal && (
        <AddProfile
          dataList={dataList}
          toggle={toggle}
          getTutorsProfileData={getTutorsProfileData}
        />
      )}

      {modal1 && (
        <Editprofile
          dataList={dataList}
          toggle={toggle1}
          profile={profile}
          getTutorsProfileData={getTutorsProfileData}
        />
      )}
    </div>
  );
};

export default Profile;
